import type { DeepString } from "@/lib/i18n";

/**
 * WUserAccount — polskie tłumaczenia widgetu user account w headerze.
 *
 * Widget pokazuje 2 stany: wylogowany (przycisk "Zaloguj się" + modal z formą)
 * i zalogowany (avatar + imię + dropdown menu z opcjami konta).
 */
export const pl = {
  /* ─── Triggery w headerze ─── */
  /** Tekst na przycisku gdy visitor niezalogowany. */
  loginButton: "Zaloguj się",
  /** Komunikat zachęcający w dropdown (gdy logged-in) — `{name}` placeholder. */
  greeting: "Witaj, {name}",
  /** Domyślne imię gdy backend nie zwrócił nic (defensive fallback). */
  defaultGreetingName: "Użytkowniku",

  /* ─── Modal (logged-out) ─── */
  modalTitle: "Logowanie",
  modalClose: "Zamknij",

  /* ─── Form login ─── */
  loginLabel: "Login lub e-mail",
  passwordLabel: "Hasło",
  submitLogin: "Zaloguj się",
  submitLoginBusy: "Logowanie…",
  /** Link do c_user_accounts katalogu — "Załóż konto" w modal'u. */
  registerLink: "Załóż konto",
  /** Link do c_user_accounts katalogu — "Zapomniałem hasła". */
  forgotPasswordLink: "Zapomniałem hasła",

  /* ─── Validation ─── */
  validationLoginRequired: "Podaj login lub adres email.",
  validationPasswordRequired: "Podaj hasło.",

  /* ─── Errors ─── */
  loginFailed: "Logowanie nie powiodło się.",
  networkError: "Błąd sieci.",

  /* ─── Dropdown (logged-in) ─── */
  /** Link do c_user_accounts katalogu (sekcja profile). */
  myAccountLink: "Twoje konto",
  /** Akcja wylogowania. */
  logoutAction: "Wyloguj",
  logoutFailed: "Nie udało się wylogować.",

  /* ─── Error states (gdy backend zwrócił error) ─── */
  errorNotLinked: "Okno nie jest powiązane z katalogiem kont użytkownika. Skontaktuj się z administratorem.",
  errorCatalogMissing: "Powiązany katalog kont użytkownika nie istnieje. Skontaktuj się z administratorem.",
  errorFetchFailed: "Nie udało się załadować widgetu konta.",
} as const;

export type WUserAccountTranslations = DeepString<typeof pl>;
